<script lang="ts" setup>
import { IconObjectFolderDark, IconObjectFolderDarkSmall } from '@cypress-design/vue-icon'
import IconsRight from './fragments/IconsRight.vue'
import TopBar from './fragments/TopBar.vue'

defineProps<{
  cwd: string
  size?: 'sm' | 'lg'
}>()
</script>

<template>
  <div class="transform rounded-lg bg-gray-1000">
    <TopBar :size="size" dark>
      <div class="grow">
        <div
          class="overflow-hidden overflow-ellipsis whitespace-nowrap rounded px-[8px] text-center text-gray-400 sm:mx-[17%] lg:mx-[25%]"
        >
          <IconObjectFolderDarkSmall
            v-if="size === 'sm'"
            stroke-color="gray-700"
            fill-color="gray-800"
            size="16"
            class="inline-block md:mr-[8px]"
          />
          <IconObjectFolderDark
            v-if="size === 'lg'"
            stroke-color="gray-700"
            fill-color="gray-800"
            size="16"
            class="inline-block md:mr-[12px]"
          />
          {{ cwd }}
        </div>
      </div>
      <IconsRight :size="size" dark />
    </TopBar>
    <slot />
  </div>
</template>
